module.exports = __webpack_public_path__ + "img/filter.0fb0584d.svg";